export default [
    {
        name: 'AWB',
        value: 's_awb',
        medLargeWidth: true
    }, 
    {
        name: 'HAWB',
        value: 's_hawb',
        medLargeWidth: true
    },
    {
        name: 'Amount',
        value: 'f_amount',
        mediumWidth: true
    }, 
    {
        name: 'Type',
        value: 's_payment_type',
        mediumWidth: true
    },
    {
        name: 'Name',
        value: 's_name'
    },
    {
        name: 'Notification Email',
        value: 's_notification_email'
    },
    {
        name: 'Date',
        value: 't_created_date',
        datetime: true,
        utc: true
    }
];